import { IconButton } from "client/Components";
import { ReactElement } from "react";
import styles from "./MobileCommentHeader.module.less";
import { generateTrackingId, setTrackingId } from "client/Misc/utils";

const rootTrackingId: string = "mobile-comment-header";

type MobileCommentHeaderProps = {
	onCancel(): void;
	header: string;
};

export const MobileCommentHeader = (props: MobileCommentHeaderProps): ReactElement => {
	const {
		header,
		onCancel
	} = props;

	return (
		<div
			{...setTrackingId(rootTrackingId)}
			className={styles.header}
		>
			<span
				className={styles.headerText}
			>
				{header}
			</span>
			<IconButton
				trackingId={generateTrackingId(rootTrackingId, "__cancel-edit")}
				kind="transparent-colored"
				icon="xmark"
				onClick={onCancel}
				size="large"
			/>
		</div>
	);
};

MobileCommentHeader.displayName = "MobileCommentHeader";
